import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Menu.css';
import { NavLink, withRouter } from 'react-router-dom';
import * as PageConstants from '../../../constants/PageTitle';

class Menu extends Component {

  toggleVisibility() {
    HTMLCollection.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];
    [].forEach.call(document.getElementsByClassName('nav-links'), link => {
      link.classList.toggle('toggle-show-links');
    });
  }

  menuVisibility() {
    if (window.innerWidth < 1000) {
      HTMLCollection.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];
      [].forEach.call(document.getElementsByClassName('nav-links'), link => {
        link.classList.add('toggle-visibility');
        link.classList.remove('toggle-show-links');
      });
    }
    else {
      HTMLCollection.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];
      [].forEach.call(document.getElementsByClassName('nav-links'), link => {
        link.classList.remove('toggle-visibility');
        link.classList.add('toggle-show-links');
      });
    }
  }

  setActiveMenu(path) {
    let link;
    const menuRouter = path.split("/")[1];
    document.getElementById("home").classList.remove('active');
    document.getElementById("stepbystep").classList.remove('active');
    document.getElementById("technical").classList.remove('active');
    document.getElementById("introduction").classList.remove('active');
    // document.getElementById("bestpractice").classList.remove('active');
    switch (menuRouter) {
      case PageConstants.STEPBYSTEP:
        link = document.getElementById("stepbystep");
        link.classList.add('active');
        return;
      case PageConstants.TECHNICAL:
        link = document.getElementById("technical");
        link.classList.add('active');
        return;
      // case PageConstants.BESTPRACTICE:
      //   link = document.getElementById("bestpractice");
      //   link.classList.add('active');
      //   return;
      case PageConstants.HOME:
        link = document.getElementById("home");
        link.classList.add('active');
        return;
      case PageConstants.INTRODUCTION:
        link = document.getElementById("introduction");
        link.classList.add('active');
        return;
      default:
        return;
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setActiveMenu(this.props.location.pathname);
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.menuVisibility);
    this.setActiveMenu(this.props.location.pathname);
  }
  
  componentWillUnmount() {
    window.removeEventListener("resize", this.menuVisibility);
  }

  render() {
    const menu = process.env.BASE_URL + "images/shared/menu.png";
    // const fblogo = process.env.BASE_URL + "images/shared/fbLogo.png";
    // const linkedinlogo = process.env.BASE_URL + "images/shared/linLogo.png";
    // const twlogo = process.env.BASE_URL + "images/shared/TwitterLogo.png";
    // const youtubeLogo = process.env.BASE_URL + "images/header/youTubeLogo.png";
    return (
      <div className="menu-share-container">
        <div className="menu-container">
          <img id="menu-toggle" src={menu} alt="menu-icon" className="toggle-visibility menu-toggle" onClick={this.toggleVisibility} />
          <div id="main-menu" className="menu-nav-link">
            <NavLink id="home" to="/home" className="nav-links" activeClassName="active" onClick={this.toggleVisibility} exact>Home</NavLink>
            <NavLink id="introduction" to="/introduction" className="nav-links" activeClassName="active" onClick={this.toggleVisibility} exact>Introduction</NavLink>
            <NavLink id="stepbystep" to="/stepByStep" className="nav-links" activeClassName="active" onClick={this.toggleVisibility} exact>Step by Step</NavLink>
            {/* <NavLink id="bestpractice" to="/bestPractice" className="nav-links" activeClassName="active" onClick={this.toggleVisibility} exact>Best Practice</NavLink> */}
            <NavLink id="technical" to="/technical" className="nav-links" activeClassName="active" onClick={this.toggleVisibility} exact>Technical</NavLink>
          </div>
        </div>
        {/* <div className="share-container">
          <span>Connect with Serverside Group</span>
          <a href="http://www.linkedin.com/groups?gid=106189" target="_blank" rel="noopener noreferrer">
            <img alt="linkedin" className="logo-image" src={linkedinlogo} />
          </a>
          <a href="https://www.facebook.com/ServersideGroup" target="_blank">
            <img src={fblogo} className="logo-image" alt="facebook" />
          </a>
          <a href="https://twitter.com/serversidegroup" target="_blank" rel="noopener noreferrer">
            <img alt="twitter" className="logo-image" src={twlogo} />
          </a>
          <a href="http://www.youtube.com/user/Serverside10" target="_blank" rel="noopener noreferrer">
          <img alt="Youtube" className="logo-image-you" src={youtubeLogo} />
            </a>
        </div> */}
      </div>
    )
  }
}

Menu.propTypes = {
  location: PropTypes.object,
  pathname: PropTypes.string
}

export default withRouter(Menu);